export enum CollaboratorType {
  Contact = 'Contact',
  User = 'User',
}
